import type { Account } from '../../core/types/Account'

export interface AccountDisplayNameOptions {
  allowNickname?: boolean
}

export function getAccountDisplayName(
  account: Account,
  options?: AccountDisplayNameOptions,
): string {
  if (options?.allowNickname === true) {
    const nickName = account.nickname?.trim()
    if (nickName) return nickName
  }

  const name = account.name?.trim()
  if (name) return name

  const feedName = account.feed_name?.trim()
  return feedName || ''
}

export default getAccountDisplayName
